export default __webpack_public_path__ + "static/media/whatsapp.f60e513b.svg";